module.exports = __webpack_public_path__ + "img/indext.85255fc1.png";